import React, { useState } from 'react';
import { Bluetooth } from 'lucide-react';

export const BluetoothPairButton = ({ onCommand }) => {
    const [connected, setConnected] = useState(false);
    const [error, setError] = useState(null);

    const handleConnect = async () => {
        try {
            setError(null);
            console.log("Requesting Bluetooth Device...");
            
            // The UUID must match the one broadcasted by the Flutter app
            const SERVICE_UUID = "0000abcd-0000-1000-8000-00805f9b34fb";
            const CHARACTERISTIC_UUID = "0000abce-0000-1000-8000-00805f9b34fb";
            
            // Note: browser requires the site to be https:// or localhost
            const device = await navigator.bluetooth.requestDevice({
                acceptAllDevices: true,
                optionalServices: [SERVICE_UUID]
            });
            
            console.log("Connecting to GATT Server...");
            const server = await device.gatt.connect();
            
            console.log("Getting Service...");
            const service = await server.getPrimaryService(SERVICE_UUID);
            
            console.log("Getting Characteristic...");
            const characteristic = await service.getCharacteristic(CHARACTERISTIC_UUID);
            
            console.log("Starting Notifications...");
            await characteristic.startNotifications();
            
            characteristic.addEventListener('characteristicvaluechanged', (event) => {
                const value = new TextDecoder().decode(event.target.value);
                console.log("Received BLE Command:", value);
                if (onCommand) {
                    onCommand(value);
                }
            });
            
            device.addEventListener('gattserverdisconnected', () => {
                setConnected(false);
                console.log("BLE Disconnected");
            });
            
            setConnected(true);
            console.log("BLE Connected!");
        } catch (err) {
            console.error("BLE Error:", err);
            setError(err.message);
        }
    };

    return (
        <div className="fixed bottom-4 left-4 z-50 flex flex-col gap-2">
            <button
                onClick={handleConnect}
                className={`flex items-center justify-center gap-2 px-4 py-2 rounded-full shadow-lg transition-colors font-medium text-sm ${
                    connected 
                        ? "bg-blue-600 text-white" 
                        : "bg-white text-slate-700 hover:bg-slate-50 border border-slate-200"
                }`}
            >
                <Bluetooth size={16} className={connected ? "text-white" : "text-blue-500"} />
                {connected ? "BLE Remote Connected" : "Pair BLE Remote"}
            </button>
            {error && (
                <span className="text-xs text-red-500 max-w-[200px] truncate bg-white px-2 py-1 rounded shadow">
                    {error}
                </span>
            )}
        </div>
    );
};
